export default __webpack_public_path__ + "static/media/logo.29bf2665.png";